import { z } from 'zod';

export const CreateHotelContactSchema = z.object({
  email: z.string().email().max(254),
  name: z.string().min(1).max(160).optional(),
  role: z.string().min(1).max(160).optional(),
  /** Promotes this contact to the hotel's default approval-batch recipient. */
  isPrimary: z.boolean().optional(),
});
export type CreateHotelContact = z.infer<typeof CreateHotelContactSchema>;

export const UpdateHotelContactSchema = z
  .object({
    email: z.string().email().max(254).optional(),
    name: z.string().max(160).nullable().optional(),
    role: z.string().max(160).nullable().optional(),
    isPrimary: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: 'Legalább egy mezőt meg kell adni' });
export type UpdateHotelContact = z.infer<typeof UpdateHotelContactSchema>;

export interface HotelContact {
  id: string;
  hotelId: string;
  name: string | null;
  email: string;
  role: string | null;
  isPrimary: boolean;
  position: number;
  createdAt: string;
  updatedAt: string;
}
